import { isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DataTablesModule } from 'angular-datatables';
import { QuillModule } from 'ngx-quill';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { MenuManagementComponent } from './menu/menu-management/menu-management.component';
import { MenuTableComponent } from './menu/menu-table/menu-table.component';
import { ToggleSwitchComponent } from './shared/toggle-switch/toggle-switch.component';
import { LanguagesComponent } from './pages/languages/languages.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';

import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RoleComponent } from './pages/role/role.component';
import { PopularDestinationsComponent } from './pages/popular-destinations/popular-destinations.component';
import { PopularDestinationsCategoryComponent } from './pages/popular-destinations-category/popular-destinations-category.component';
import { QuotationLeaderComponent } from './pages/quotation-leader/quotation-leader.component';
import { LeadershipComponent } from './pages/leadership/leadership.component';
import { NewsComponent } from './pages/news/news.component';
import { PolicyLawsComponent } from './pages/policy-laws/policy-laws.component';
import { DocumentComponent } from './pages/document/document.component';
import { DocumentTypeComponent } from './pages/document-type/document-type.component';
import { NewsCategoryComponent } from './pages/news-category/news-category.component';
import { LoginComponent } from './pages/login/login.component';
import { ProfileComponent } from './pages/profile/profile.component';

import { NgSelectModule } from '@ng-select/ng-select';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { StorageUrlRewriteInterceptor } from './shared/storage-url-rewrite.interceptor';
import { EServiceCategoryComponent } from './pages/e-service-category/e-service-category.component';
import { EServiceComponent } from './pages/e-service/e-service.component';
import { LinksComponent } from './pages/links/links.component';
import { LocationComponent } from './pages/location/location.component';
import { UserComponent } from './pages/user/user.component';
import { ContactMessageComponent } from './pages/contact-message/contact-message.component';
import { StatisticsV2Component } from './pages/statistics-v2/statistics-v2.component';
import { TourismMapComponent } from './pages/tourism-map/tourism-map.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    MenuManagementComponent,
    MenuTableComponent,
    ToggleSwitchComponent,
    LanguagesComponent,
    DashboardComponent,
    RoleComponent,
    PopularDestinationsComponent,
    PopularDestinationsCategoryComponent,
    QuotationLeaderComponent,
    LeadershipComponent,
    PolicyLawsComponent,
    DocumentComponent,
    DocumentTypeComponent,
    NewsCategoryComponent,
    NewsComponent,
    LoginComponent,
    ProfileComponent,
    EServiceCategoryComponent,
    EServiceComponent,
    LinksComponent,
    LocationComponent,
    UserComponent,
    ContactMessageComponent,
    StatisticsV2Component,
    TourismMapComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    DataTablesModule,
    QuillModule.forRoot(),
    NgSelectModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: StorageUrlRewriteInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
